import {useEffect, useState} from 'react';
const photos = [
  { display: "/images_display/img_1.JPG", thumb: "/images_grid/img_1.JPG", alt: "Photo 1" },
  { display: "/images_display/img_2.JPG", thumb: "/images_grid/img_2.JPG", alt: "Photo 2" },
  { display: "/images_display/img_3.JPG", thumb: "/images_grid/img_3.JPG", alt: "Photo 3" },
  { display: "/images_display/img_4.JPG", thumb: "/images_grid/img_4.JPG", alt: "Photo 4" },
  { display: "/images_display/img_5.JPG", thumb: "/images_grid/img_5.JPG", alt: "Photo 5" },
  { display: "/images_display/img_6.JPG", thumb: "/images_grid/img_6.JPG", alt: "Photo 6" },
  { display: "/images_display/img_7.JPG", thumb: "/images_grid/img_7.JPG", alt: "Photo 7" },
  { display: "/images_display/img_8.JPG", thumb: "/images_grid/img_8.JPG", alt: "Photo 8" },
  { display: "/images_display/img_9.JPG", thumb: "/images_grid/img_9.JPG", alt: "Photo 9" },
  { display: "/images_display/img_10.JPG", thumb: "/images_grid/img_10.JPG", alt: "Photo 10" },
  { display: "/images_display/img_11.JPG", thumb: "/images_grid/img_11.JPG", alt: "Photo 11" },
  { display: "/images_display/img_12.JPG", thumb: "/images_grid/img_12.JPG", alt: "Photo 12" },
  { display: "/images_display/img_13.JPG", thumb: "/images_grid/img_13.JPG", alt: "Photo 13" },
  { display: "/images_display/img_14.JPG", thumb: "/images_grid/img_14.JPG", alt: "Photo 14" },
];


function Photography() {
    const [activePhoto, setActivePhoto] = useState(null);

    let openPhoto = (index) => {setActivePhoto(index)};

    let closePhoto = () => {setActivePhoto(null)};

    useEffect(() => {
      if (activePhoto == null) {
        return undefined;
      }

      const originalHtmlOverflow = document.documentElement.style.overflow;
      const originalBodyStyle = {
        overflow: document.body.style.overflow,
      };

      const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
          setActivePhoto(null);
        }
      };

      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';

      window.addEventListener('keydown', handleKeyDown);

      return () => {
        window.removeEventListener('keydown', handleKeyDown);
        document.documentElement.style.overflow = originalHtmlOverflow;
        document.body.style.overflow = originalBodyStyle.overflow;
      };
    }, [activePhoto]);




  return (
<section className="page-shell photography-page" id="photography_page">
  <div className="page-hero projects-hero">
    <p className="eyebrow">Gallery</p>
    <h1>Photo Gallery</h1>
      <p className="hero-copy muted-copy">
      Shot on my D5300 (mostly)
  </p>
  </div>



      <div className="photo-grid">
        {photos.map((photo,index) => (<button 
        key={photo.display} type="button" className="photo_btn" 
            onClick={() => openPhoto(index)} style={{animationDelay: `${index * 0.05}s`}}>
        <img
          src={photo.thumb}
          alt={photo.alt}
          className="photo_img"
          loading={index < 6 ? "eager" : "lazy"}
          fetchPriority={index < 3 ? "high" : "auto"}
          decoding="async"
        />
        </button>))}
      </div>

        {/** currently open image */}


        {activePhoto != null &&(
            <div className="photo_lightbox" onClick={closePhoto} role="dialog" aria-modal="true">
                <div className="photo_lightbox_inner" onClick={(e)=>e.stopPropagation()}>  {/**so clicks on image dont close */}
                  <button
                    type="button"
                    className="photo_lightbox_close"
                    aria-label="Close photo viewer"
                    onClick={closePhoto}
                  >
                    ×
                  </button>
                  <div className="photo_lightbox_stage">
                    <img
                      src={photos[activePhoto].display}
                      alt={photos[activePhoto].alt}
                      className='photo_lightbox_image'
                      decoding="async"
                    />
                  </div>
                </div>
            </div>
        )}

    </section>



  );
}





export default Photography;
